<ng-container *transloco="let t">
    <h2 class="mb-4">{{ t('choose_qr_payment') }}</h2>
    <div class="w-full grid grid-cols-3 lg:grid-cols-2 2xl:grid-cols-3 gap-2 mb-2 payment_type">
        <tui-radio-block *ngFor="let item of optionsQr$ | async"
                         [formControl]="paymentQrCtrl"
                         contentAlign="right"
                         [size]="'m'"
                         [item]="item.key"
                         [hideRadio]="true">
            <div class="flex items-center flex-col gap-2 content-payment justify-center">
                <img [src]="item.image"
                     alt=""
                     srcset=""
                     class="icon-custom">
                <span class="ml-1.5 break-words whitespace-normal"> {{ item.name }}</span>
                <tui-svg src="icon::check_v2"
                         class="icon-absolute"></tui-svg>
            </div>
        </tui-radio-block>
    </div>
    <!-- <button tuiButton
            class="w-full mt-2"
            appearance="primary"
            size="m"
            [disabled]="!this.paymentQrCtrl.value"
            (click)="submit()">
        {{ t('confirm') }}
    </button> -->
</ng-container>
